import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const IncidentDivisionDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `Incident Division (#${item.id}): ${item.name}`}
  />
)

export default IncidentDivisionDelete
